import api from 'services/api';

import { HttpCodes } from 'v2/resources/types/httpCode';
import { IDataChat } from 'v2/resources/types/chat';

export const ChatServices = {
  postChat: async (data: IDataChat): Promise<string> => {
    const response = await api.post('/chat', data, {
      responseType: 'stream',
    });

    if (
      response.status === HttpCodes.SUCCESS ||
      response.status === HttpCodes.SUCCESS_CREATED
    ) {
      return response.data;
    }
    return 'ERROR';
  },
};
